export default "__VITE_ASSET__C$IMWsLt__"